import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgotPassword/forgotPassword.component';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './auth/register/register.component';
import { AddStudentProfileComponent } from './student/add-student-profile/add-student-profile.component';
import { StudentProfileSummaryComponent } from './student/student-profile-summary/student-profile-summary.component';
import { PersonalInfoComponent } from './settings-offcanvas/personal-info/personal-info.component';
import { ChangePasswordComponent } from './settings-offcanvas/change-password/change-password.component';
import { InformationSchoolEnrollmentComponent } from './school/information-school-enrollment/information-school-enrollment.component';
import { ApplicationSubmittedComponent } from './school/application-submitted/application-submitted.component'; 


export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'add-student-profile', component: AddStudentProfileComponent },
  { path: 'personal-info', component: PersonalInfoComponent },
  { path: 'student-profile-summary', component: StudentProfileSummaryComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'home', component: HomeComponent },
  { path: 'information-school-enrollment', component: InformationSchoolEnrollmentComponent },
  { path: 'application-submitted', component: ApplicationSubmittedComponent }, 
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];